<!--
 * @Description: 
 * @Autor: Dai YueLin
 * @Date: 2022-10-13 13:18:39
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-10-13 15:18:43
-->
<template>
  <div class="view_container">
    <n-space vertical>
      <n-layout has-sider class="view_main">
        <n-layout-sider
          bordered
          collapse-mode="width"
          :collapsed-width="64"
          :width="240"
          :collapsed="collapsed"
          show-trigger
          @collapse="setCollapsed(true)"
          @expand="setCollapsed(false)"
        >
          <sider :collapsed="collapsed"></sider>
        </n-layout-sider>
        <n-layout class="main_container">
          <VersionNoice></VersionNoice>
          <div class="main">
            <router-view v-if="isRouterAlive" :key="$route.fullPath" v-slot="{ Component }">
              <n-spin class="main-spin" :show="store.state.common.loading">
                <component :is="Component" />
              </n-spin>
            </router-view>
          </div>
        </n-layout>
      </n-layout>
    </n-space>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { NSpin, NLayout, NLayoutSider, NSpace } from 'naive-ui';

import sider from '@/layouts/sider.vue';
import VersionNoice from '@/components/VersionNoice/index.vue';

const SIDEBAR_KEY = 'EDM-SIDEBAR'; // 1 open 2 close
const store = useStore();

const isRouterAlive = ref(true);
const collapsed = computed(() => store.state.user.menuCollapsed);
const setCollapsed = (flag: boolean) => {
  store.commit('user/SET_COLLAPSED', flag);
  window.localStorage.setItem(SIDEBAR_KEY, flag ? '1' : '2');
};

onMounted(() => {
  const sidebarStorage = window.localStorage.getItem(SIDEBAR_KEY);
  if (sidebarStorage === '1') {
    store.commit('user/SET_COLLAPSED', true);
  } else if (sidebarStorage === '2') {
    store.commit('user/SET_COLLAPSED', false);
  }
});
</script>

<style lang="scss" scoped>
.view_main {
  display: flex;
  height: calc(100vh - 56px);
}
.aside {
  width: 280px;
  min-width: 280px;
  position: relative;
}
.main_container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main {
  overflow-y: scroll;
  background-color: #f7f8fd;
  padding: 32px 24px;
  position: relative;
  flex: 1;
  height: 100%;
}
</style>

<style lang="scss">
.main-spin {
  height: 100%;

  .n-spin-content {
    height: 100%;
  }
}
</style>
